app.controller('StaffCustomerEntryController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    $scope.customer_code = $stateParams.customer_code;
    $scope.waiting_for_customer = $scope.waiting_for_orders = !!$scope.customer_code;

    $scope.view_model = {
        search_type_id: "recent"
    }

    const orderHistoryModel = $rootScope.service.order_history.getSubmittedModel(null, $scope.customer_code)

    $scope.search_model = new $rootScope.model_constructor.SearchModel();

    $scope.order_request_limit = function () {
        return $scope.view_model.search_type_id === "recent" ? orderHistoryModel.limit : $scope.search_model.limit;
    }

    const orderListModels = {
        recent: new $rootScope.model_constructor.ListModel(),
        archive: new $rootScope.model_constructor.ListModel()
    }

    $scope.getOrderListModel = function () {
        return orderListModels[$scope.view_model.search_type_id];
    }

    $rootScope.service.account.requireUserData(function () {
        if ($rootScope.model.staff.is_staff_or_rep) {
            if ($scope.waiting_for_customer) {
                $rootScope.service.staff.requestCustomerData($scope.customer_code, function (success, customerData) {
                    $scope.visible_customer = success ? customerData : null;
                    $scope.waiting_for_customer = false;

                });

                orderHistoryModel.requestOrders(function () {
                    orderListModels.recent.cloneList(orderHistoryModel.choiceList());
                    $scope.waiting_for_orders = false;
                })
            }
        } else {
            $scope.waiting_for_customer = false;
            $scope.waiting_for_orders = false;
        }
    })

    $scope.archiveSearch = function () {

        const searchModel = $scope.search_model;
        searchModel.prepare();
        $rootScope.service.order_history.requestArchive("order", orderListModels.archive, searchModel, $scope.customer_code);
    };


    $scope.loadCustomer = function (customerCode) {

        $rootScope.service.staff.setStaffRepCustomerCode(customerCode, function (success, customerData) {
            $rootScope.service.order.startNewOrder();
            $state.go('myba.dashboard');
        })

    }

    $scope.loadOrder = function (id) {
        $state.go('myba.staff-customer-order-entry', {order_id: id, customer_code: $scope.customer_code});
    };

}]);